import { render, staticRenderFns } from "./questionnaireItem.vue?vue&type=template&id=228f2c4a"
import script from "./questionnaireItem.vue?vue&type=script&lang=js"
export * from "./questionnaireItem.vue?vue&type=script&lang=js"
import style0 from "./questionnaireItem.vue?vue&type=style&index=0&id=228f2c4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports